import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SchadenummerComponent } from '@app/shared/ui/schadenummer/schadenummer.component';

@NgModule({
    declarations: [
        SchadenummerComponent,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        SchadenummerComponent,
    ],
})
export class SchadenummerModule {
}
